export const ModalName = {
  AccountBlocked: 'account-blocked-modal',
  AccountEdit: 'account-edit-modal',
  AccountEditLabel: 'account-edit--label-modal',
  AccountSwitcher: 'account-switcher-modal',
  AcrossRoutingInfo: 'across-routing-info-modal',
  ActionCannotBeCompletedModal: 'action-cannot-be-completed-modal',
  AddLiquidity: 'add-liquidity',
  AddPasskey: 'add-passkey',
  AddressClaim: 'address-claim-modal',
  AddressQR: 'address-qr-modal',
  AddWallet: 'add-wallet-modal',
  AppRatingModal: 'app-rating-modal',
  BackupReminder: 'backup-reminder-modal',
  BackupReminderWarning: 'backup-reminder-warning-modal',
  Bag: 'bag-modal',
  Banners: 'banners-modal',
  BiometricsModal: 'biometrics-modal',
  BlockedAccount: 'blocked-account',
  BlockedAddress: 'blocked-address',
  BridgedAsset: 'bridged-asset-modal',
  BridgedAssetNav: 'bridged-asset-nav-modal',
  BridgingWarning: 'bridging-warning-modal',
  BuyNativeToken: 'buy-native-token-modal',
  CancelOrders: 'cancel-orders-modal',
  ChooseProfilePhoto: 'choose-profile-photo-modal',
  ChooseProviderModal: 'choose-provider-modal',
  ChooseUnitag: 'choose-unitag-modal',
  ClaimFee: 'claim-fee-modal',
  ClaimPopup: 'claim-popup',
  CloudBackupInfo: 'cloud-backup-info-modal',
  CompatibleAddressWarning: 'compatible-address-warning-modal',
  ConfirmCreatePosition: 'confirm-create-position-modal',
  ConfirmSwap: 'confirm-swap-modal',
  ConnectionError: 'connection-error-modal',
  ConnectionsDappListModal: 'connections-dapp-list-modal',
  ContractAddressExplainer: 'contract-address-explainer-modal',
  CreateNewPassword: 'create-new-password-modal',
  CreatePasskey: 'create-passkey-modal',
  CreatePosition: 'create-position-modal',
  ConfirmDisableSmartWalletScreen: 'confirm-disable-smart-wallet-screen',
  CurrencySearch: 'currency-search-modal',
  DappRequest: 'dapp-request',
  Delegate: 'delegate',
  DelegationMismatch: 'delegation-mismatch-modal',
  DeletePasskeySpeedbump: 'delete-passkey-speedbump-modal',
  DeletePasskey: 'delete-passkey-modal',
  DevFlags: 'dev-flags-modal',
  Dialog: 'dialog-modal',
  DownloadApp: 'download-app-modal',
  DynamicFeeTierSpeedbump: 'dynamic-fee-tier-speedbump-modal',
  EditLabelSettingsModal: 'edit-label-settings-modal',
  EditProfileSettingsModal: 'edit-profile-settings-modal',
  ENSClaimPeriod: 'ens-claim-period',
  EnterPassword: 'enter-password-modal',
  EstimatedTimeInfo: 'estimated-time-info-modal',
  ExchangeTransferModal: 'exchange-transfer-modal',
  Execute: 'execute',
  Experiments: 'experiments',
  Explore: 'explore-modal',
  ExploreProtocolFilter: 'explore-pools-protocol-filter',
  ExtensionLaunchPromotionalModal: 'extension-launch-promotional-modal',
  FaceIDWarning: 'face-id-warning',
  FeatureFlags: 'feature-flags-modal',
  FeeClaim: 'fee-claim-modal',
  FeeTierSearch: 'fee-tier-search-modal',
  FiatCurrencySelector: 'fiat-currency-selector',
  FiatOffRampConfirmTransfer: 'fiat-off-ramp-confirm-transfer',
  FiatOffRampConfirmTransferError: 'fiat-off-ramp-confirm-transfer-error',
  FiatOffRampUnsupportedTokenModal: 'fiat-off-ramp-unsupported-token-modal',
  FiatOnramp: 'fiat-onramp-modal',
  FiatOnRampAggregator: 'fiat-on-ramp-aggregator',
  FiatOnRampCountryList: 'fiat-on-ramp-country-list',
  FiatOnRampTokenSelector: 'fiat-on-ramp-token-selector',
  ForceUpgradeModal: 'force-upgrade-modal',
  ForgotPassword: 'forgot-password',
  FOTInfo: 'fee-on-transfer',
  FundWallet: 'fund-wallet',
  GetTheApp: 'get-the-app',
  GettingStartedModal: 'getting-started-modal',
  Help: 'help-modal',
  HiddenNFTInfoModal: 'hidden-nft-info-modal',
  HiddenTokenInfoModal: 'hidden-token-info-modal',
  Hook: 'hook',
  KoreaCexTransferInfoModal: 'korea-cex-transfer-info-modal',
  LanguageSelector: 'language-selector-modal',
  Legal: 'legal',
  LowNativeBalanceWarning: 'low-native-balance-warning',
  LpIncentiveClaimModal: 'lp-incentive-claim-modal',
  ManageWalletsModal: 'manage-wallets-modal',
  MigrateLiquidity: 'migrate-liquidity',
  NativeBalanceInfo: 'native-balance-info',
  NetworkFeeInfo: 'network-fee-info',
  NetworkSelector: 'network-selector-modal',
  NewAddressSpeedBump: 'new-address-speed-bump',
  NewAddressWarning: 'new-address-warning-modal',
  NftCollection: 'nft-collection',
  NftListing: 'nft-listing-modal',
  NftTxComplete: 'nft-tx-complete-modal',
  NotFound: 'not-found',
  NotificationsOSSettings: 'notifications-os-settings-modal',
  OffchainActivity: 'offchain-activity-modal',
  OnDeviceRecoveryConfirmation: 'on-device-recovery-confirmation',
  OtpInputExpired: 'otp-input-expired',
  OtpScanInput: 'otp-scan-input',
  PasskeyManagement: 'passkey-management-modal',
  PasskeysHelp: 'passkeys-help-modal',
  PriceImpact: 'price-impact-modal',
  PrivacyChoices: 'privacy-choices-modal',
  PermissionsModal: 'permissions-modal',
  PortfolioBalanceModal: 'portfolio-balance-modal',
  SmartWalletNudge: 'post-swap-smart-wallet-nudge',
  PrivacyPolicy: 'privacy-policy',
  PrivateKeySpeedBumpModal: 'private-key-speed-bump-modal',
  QRCodeNetworkInfo: 'qr-code-network-info',
  Queue: 'queue',
  QueuedOrderModal: 'queued-order-modal',
  ReceiveCryptoModal: 'receive-crypto-modal',
  RecentlyConnectedModal: 'recently-connected-modal',
  ReceiveCryptoQr: 'receive-crypto-qr',
  RecipientSelectErc20Warning: 'recipient-select-erc20-warning',
  RecipientSelectNewWarning: 'recipient-select-new-warning',
  RecipientSelectSelfSendWarning: 'recipient-select-self-send-warning',
  RecipientSelectSmartContractWarning: 'recipient-select-smart-contract-warning',
  RecipientSelectViewOnlyWarning: 'recipient-select-view-only-warning',
  RecoverySpeedBump: 'recovery-speed-bump',
  RemoveLiquidity: 'remove-liquidity',
  RemoveSeedPhraseWarningModal: 'remove-seed-phrase-warning-modal',
  RemoveWallet: 'remove-wallet-modal',
  ResetCreatePositionsForm: 'reset-create-positions-form',
  RestoreWallet: 'restore-wallet-modal',
  RestoreWalletSeedPhrase: 'restore-wallet-seed-phrase-modal',
  Scantastic: 'scantastic',
  SmartWalletActionRequiredModal: 'smart-wallet-action-required-modal',
  SmartWalletAdvancedSettingsModal: 'smart-wallet-advanced-settings-modal',
  SmartWalletConfirmModal: 'smart-wallet-confirm-modal',
  SmartContractSpeedBump: 'smart-contract-speed-bump',
  SmartWalletInsufficientFundsOnNetworkModal: 'smart-wallet-insufficient-funds-modal',
  ScreenshotWarning: 'screenshot-warning',
  Search: 'search-modal',
  SeedPhraseWarningModal: 'seed-phrase-warning-modal',
  Send: 'send-modal',
  SendReview: 'send-review-modal',
  SendWarning: 'send-warning-modal',
  Settings: 'settings',
  SettingsAppearance: 'appearance-settings-modal',
  SignIn: 'sign-in-modal',
  SignUp: 'sign-up-modal',
  SlippageInfo: 'slippage-info-modal',
  SlippageWarningModal: 'slippage-warning-modal',
  SmartWalletCreatedModal: 'smart-wallet-created-modal',
  SmartWalletDisableModal: 'smart-wallet-disable-modal',
  SmartWalletEducationalModal: 'smart-wallet-educational-modal',
  SmartWalletEnabledModal: 'smart-wallet-enabled-modal',
  SmartWalletInfoModal: 'smart-wallet-info-modal',
  SmartWalletUpgradeModal: 'smart-wallet-upgrade-modal',
  SmartWalletUnavailableModal: 'smart-wallet-unavailable-modal',
  SmartWalletWarningModal: 'smart-wallet-warning-modal',
  SolanaPromo: 'solana-promo-modal',
  StorageWarning: 'storage-warning-modal',
  Swap: 'swap-modal',
  SwapError: 'swap-error-modal',
  SwapProtection: 'swap-protection-modal',
  SwapReview: 'swap-review-modal',
  SwapSettings: 'swap-settings-modal',
  SwapSettingsDefaultRoutingInfo: 'swap-settings-default-routing-info-modal',
  SwapWarning: 'swap-warning-modal',
  TestnetMode: 'testnet-mode-modal',
  TestnetSwitchModal: 'testnet-switch-modal',
  TokenSafety: 'token-safety-modal',
  TokenSelector: 'token-selector',
  TokenSelectorWeb: 'token-selector-modal',
  TokenWarning: 'token-warning',
  TokenWarningModal: 'token-warning-modal',
  TooltipContent: 'tooltip-content',
  TransactionActions: 'transaction-actions',
  TransactionCancellation: 'transaction-cancellation-modal',
  TransactionConfirmation: 'transaction-confirmation-modal',
  TransactionDetails: 'transaction-details',
  TokenNotFound: 'token-not-found',
  PoolNotFound: 'pool-not-found',
  UkDisclaimer: 'uk-disclaimer-modal',
  UnichainInstantBalanceModal: 'unichain-instant-balance-modal',
  UniconsDevModal: 'unicons-dev-modal',
  UniconsV2: 'unicons-v2-intro-modal',
  UniswapXInfo: 'uniswapx-info-modal',
  UnitagsChange: 'unitags-change-modal',
  UnitagsChangeConfirm: 'unitags-change-confirm-modal',
  UnitagsDelete: 'unitags-delete-modal',
  UnitagsIntro: 'unitags-intro-modal',
  UniWalletConnect: 'uniwallet-connect-modal',
  UwULinkErc20SendModal: 'uwulink-erc20-send-modal',
  VerifyPasskey: 'verify-passkey-modal',
  V4HooksInfo: 'v4-hooks-info-modal',
  ViewOnlyExplainer: 'view-only-explainer-modal',
  ViewSeedPhraseWarning: 'view-seed-phrase-warning',
  Vote: 'vote',
  WaitingForBiometricsEnrollment: 'waiting-for-biometrics-enrollment-modal',
  WalletConnectScan: 'wallet-connect-scan-modal',
  WCDappConnectedNetworks: 'wc-dapp-connected-networks-modal',
  WCPendingConnection: 'wc-pending-connection-modal',
  WCSignRequest: 'wc-sign-request-modal',
  WCViewOnlyWarning: 'wc-view-only-warning-modal',
  Wormhole: 'wormhole-modal',
  // alphabetize additional values.
} as const

export type ModalNameType = (typeof ModalName)[keyof typeof ModalName]
